import React from 'react'
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {routesBase} from "v4/data/appRoutes"
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import Loader from "v4/components/ui/Loader/Loader";
import FormRender from "v4/components/form/FormRender/FormRender";
import SubmitButton from "v4/components/ui/SubmitButton/SubmitButton";
import PolButton from "v4/components/ui/PolButton/PolButton";
import useModuleConfigurationsForm
    from "v4/pages/admin/ModuleConfigurations/ModuleConfigurationsForm/hooks/useModuleConfigurationsForm";

export default function ModuleConfigurationsForm({customerId, id, moduleId}) {
    const {t} = usePolTranslation();
    const {
        form,
        isLoadingForm,
        isLoadingSave,
        handleSave,
    } = useModuleConfigurationsForm(customerId, id, moduleId);

    return (
        <AdminCard
            title={t('manage_module_configurations')}
            CardHeaderTools={() => (
                <>
                    <PolButton to={`${routesBase.adminModuleConfiguration}/${customerId}/${moduleId}`}>
                        {t('retour')}
                    </PolButton>
                    <SubmitButton
                        isLoading={isLoadingSave}
                        formId="moduleConfigurationForm"
                    >
                        {t('sauvegarder')}
                    </SubmitButton>
                </>
            )}
        >
            {
                (isLoadingForm || isLoadingSave || !form)
                    ? <Loader message="Chargement..."/>
                    : (
                        <FormRender
                            form={form}
                            onSubmit={handleSave}
                            formId="moduleConfigurationForm"
                        />
                    )
            }
        </AdminCard>
    )
}
